module.exports = "//static.hsappstatic.net/ContentComponents/static-2.70275/img/website-page-zero.svg"